import { digObject, formatDate } from '@domain-group/javascript-utils'

import { Box, DashboardModule, Text } from '@domain-group/suit-theme'

import PublicationEditionHeader from '@components/PublicationEditionHeader'

import usePublicationEdition from '@hooks/usePublicationEdition'

import AgencyGroup from './AgencyGroup'

interface PublicationEditionGroupProps {
  editionAgencies: object,
  orderCount: number,
  publicationEditionId: number,
}

const PublicationEditionGroup = (props: PublicationEditionGroupProps) => {
  const { editionAgencies, orderCount, publicationEditionId } = props

  const { publication, publicationEdition } = usePublicationEdition({ id: publicationEditionId })

  const secondaryText = orderCount === 1 ? '1 Editorial' : `${orderCount} Editorials`

  const editorialDeadline = digObject(publicationEdition, 'dates.editorial.date_time', '')
  const formattedDeadline = formatDate(editorialDeadline, 'dd/MM/yyyy HH:mm', "ccc dd LLL y 'at' h:mma")

  return (
    <DashboardModule
      customHeader={(
        <PublicationEditionHeader
          publicationEdition={publicationEdition}
          // @ts-expect-error TS2339
          publicationTitle={publication.title}
        >
          <Text color="faintGrey" fontSize="small" marginBottom="small">
            {secondaryText}
          </Text>

          <PublicationEditionHeader.Deadline deadline={formattedDeadline} />
        </PublicationEditionHeader>
      )}
    >
      <Box flexDirection="column">
        {Object.values(editionAgencies).map((editionAgency, i, arr) => (
          <AgencyGroup
            editionAgency={editionAgency}
            isLastGroup={arr.length - 1 === i}
            key={editionAgency.id}
          />
        ))}
      </Box>
    </DashboardModule>
  )
}

export default PublicationEditionGroup
